import { __exports as esCookie } from './_virtual-es-cookie2.js';

var hasRequiredEsCookie;

function requireEsCookie () {
	if (hasRequiredEsCookie) return esCookie;
	hasRequiredEsCookie = 1;
	var __assign = (esCookie && esCookie.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	esCookie.__esModule = true;
	function stringifyAttribute(name, value) {
	    if (!value) {
	        return '';
	    }
	    var stringified = '; ' + name;
	    if (value === true) {
	        return stringified; // boolean attributes shouldn't have a value
	    }
	    return stringified + '=' + value;
	}
	function stringifyAttributes(attributes) {
	    if (typeof attributes.expires === 'number') {
	        var expires = new Date();
	        expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
	        attributes.expires = expires;
	    }
	    return stringifyAttribute('Expires', attributes.expires ? attributes.expires.toUTCString() : '')
	        + stringifyAttribute('Domain', attributes.domain)
	        + stringifyAttribute('Path', attributes.path)
	        + stringifyAttribute('Secure', attributes.secure)
	        + stringifyAttribute('SameSite', attributes.sameSite);
	}
	function encode(name, value, attributes) {
	    return encodeURIComponent(name)
	        .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent) // allowed special characters
	        .replace(/\(/g, '%28').replace(/\)/g, '%29') // replace opening and closing parens
	        + '=' + encodeURIComponent(value)
	        // allowed special characters
	        .replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent)
	        + stringifyAttributes(attributes);
	}
	esCookie.encode = encode;
	function parse(cookieString) {
	    var result = {};
	    var cookies = cookieString ? cookieString.split('; ') : [];
	    var rdecode = /(%[\dA-F]{2})+/gi;
	    for (var i = 0; i < cookies.length; i++) {
	        var parts = cookies[i].split('=');
	        var cookie = parts.slice(1).join('=');
	        if (cookie.charAt(0) === '"') {
	            cookie = cookie.slice(1, -1);
	        }
	        try {
	            var name_1 = parts[0].replace(rdecode, decodeURIComponent);
	            result[name_1] = cookie.replace(rdecode, decodeURIComponent);
	        }
	        catch (e) {
	            // ignore cookies with invalid name/value encoding
	        }
	    }
	    return result;
	}
	esCookie.parse = parse;
	function getAll() {
	    return parse(document.cookie);
	}
	esCookie.getAll = getAll;
	function get(name) {
	    return getAll()[name];
	}
	esCookie.get = get;
	function set(name, value, attributes) {
	    document.cookie = encode(name, value, __assign({ path: '/' }, attributes));
	}
	esCookie.set = set;
	function remove(name, attributes) {
	    set(name, '', __assign(__assign({}, attributes), { expires: -1 }));
	}
	esCookie.remove = remove;
	return esCookie;
}

export { requireEsCookie as __require };
//# sourceMappingURL=node_modules-es-cookie-src-es-cookie.js.map
